// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import PublicView from '../layouts/PublicView';
import Button from '../shared/Button';

const FourOFour = () => {
  const { t } = useTranslation('404');

  return (
    <PublicView>

      <div className='fourOFour form' style={{ textAlign: 'center' }}>
        <h1 className='is-centered'>{t('not_found_title')}</h1>
        <p className='is-centered'>
          {t('not_found_msg')}
        </p>
        <Button
          className='btn btn-primary'
          urlTo='/'
          label={t('back_to_dash')}
        />

      </div>
    </PublicView>
  );
};

export default FourOFour;



// WEBPACK FOOTER //
// ./src/components/pages/404.js